import { useAuth } from '../AuthContext';
import { Navigate } from 'react-router-dom';

// Tela do goleiro: somente perfil Goleiro.
export function GoleiroMiddleware({ children }) {
  const { isAuthenticated, userLogado } = useAuth();
  if (!isAuthenticated) return <Navigate to="/goleiro/login" />;
  if (userLogado?.perfil !== 'Goleiro') return <Navigate to="/painel" />;
  return children;
}
